<template>
  <v-text-field
    ref="input"
    :value="formattedValue"
    v-currency="options"
    @change="onChange"
    @input="onInput"
    outlined
    :errorMessages="errorMessages"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
		@blur="$emit('blur')"
  />
</template>

<script>
import { getValue, setValue } from 'vue-currency-input';

export default {
  name: 'CurrencyField',
  props: {
    value: {
      type: Number,
      default: null,
    },
    options: {
      type: Object,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    lengthToPoint: {
      type: Number,
      default: 13,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formattedValue: null,
    };
  },
  watch: {
    value(value) {
      this.setValue(value);
    },
  },
  mounted() {
    this.setValue(this.value);
  },
  methods: {
    setValue(value) {
      const newVal = value / 100;
      setValue(this.$refs.input, newVal || (newVal === 0 ? 0 : null));
    },
    onInput(value) {
      this.editValue('input', value);
    },
    onChange(value) {
      this.editValue('change', value);
    },
    onEmit(nameEmit, value) {
      this.$emit(nameEmit, +(getValue(this.$refs.input) * 100).toFixed());
      this.formattedValue = value;
    },
    editValue(nameEmit, value) {
      const lengthToPoint = this.lengthToPoint;
      const trimStr = value.replace(/\s+/g, '');
      if (trimStr.length > lengthToPoint && !trimStr.includes(',')) {
        const start = trimStr.slice(0, lengthToPoint);
        const end = trimStr.slice(lengthToPoint);
        setValue(this.$refs.input, `${start}.${end}`);
      } else {
        this.$emit(nameEmit, +(getValue(this.$refs.input) * 100).toFixed());
        this.formattedValue = value;
      }
    },
  },
};
</script>
